import _ from 'lodash';

// Directives utilisées comme clé d'un objet (ex: { $replace: true }).
const keyDirectives = ['$remove', '$replace', '$index', '$append'];
// Directives utilisées comme valeur (ex: { a: '$remove' }).
const valueDirectives = ['$remove'];

export default function removeDirectives(value) {
  if (valueDirectives.includes(value)) return undefined;
  if (!_.isPlainObject(value)) return value;
  if (value.$remove) return undefined;

  const obj = _.omitBy(value, (v, k) => valueDirectives.includes(v) || keyDirectives.includes(k));

  return _.mapValues(obj, v => {
    if (!_.isArray(v)) {
      return removeDirectives(v);
    }
    const newValue = v.map(item => {
      const newItem = removeDirectives(item);
      return _.isEmpty(newItem) && !_.isEmpty(item) ? undefined : newItem;
    });
    return _.reject(newValue, _.isUndefined);
  });
}

export function removeKeyDirectives(value) {
  if (!_.isPlainObject(value)) return value;

  return _.omitBy(value, (v, k) => keyDirectives.includes(k));
}
